import React from 'react';
import { IconProps } from './model/IconInterface';

const AsteriskIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="12" y1="4" x2="12" y2="20" /><line x1="5.07" y1="8" x2="18.93" y2="16" /><line x1="18.93" y1="8" x2="5.07" y2="16" />
    </svg>
  );
};

export default AsteriskIcon;
